import Base from '../Pages/Base'
import List from '../Pages/List'
import Form from '../Pages/Form'

export default [
	{
		path: 'site/multimidias',
		component: Base,
		children: [
			{
				path: '',
				name: 'MultimidiasList',
				component: List,
				meta: {
					path: '/site/multimidias',
					pai: 'Site',
					title: 'Admin - Multimídia',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Multimídia',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: 'novo',
				name: 'MultimidiasNovo',
				component: Form,
				meta: {
					path: '/site/multimidias',
					pai: 'Site',
					title: 'Admin - Multimídia - Novo',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Multimídia',
						class: '',
						active: false,
						url: '/site/multimidias'
					},
					{
						pagina: 'Novo',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			},
			{
				path: ':id',
				name: 'MultimidiasEditar',
				component: Form,
				meta: {
					path: '/site/multimidias',
					pai: 'Site',
					title: 'Admin - Multimídia - Editar',
					navigation: [{
						pagina: 'Home',
						class: 'ace-icon fa fa-home home-icon',
						active: false,
						url: '/'
					},
					{
						pagina: 'Multimídia',
						class: '',
						active: false,
						url: '/site/multimidias'
					},
					{
						pagina: 'Editar',
						class: '',
						active: true,
						url: false
					}],
					noCache: true
				}
			}
		]
	}
]